import { dayjs } from '../../libs/day';
import { ICalendayDay } from './types';

export const getFormattedWeekDays = (): string[] => {
  const weekDays = [];

  for (let i = 1; i <= 7; i++) {
    const day = dayjs().day(i).format('ddd').replace('.', '');

    weekDays.push(day);
  }

  return weekDays;
};

export const getDaysForCurrentMonth = (
  currentDate: dayjs.Dayjs,
): ICalendayDay[] => {
  const daysInMonth = currentDate.daysInMonth();

  const days: ICalendayDay[] = [];

  for (let index = 0; index < daysInMonth; index++) {
    const dayOfMonth = index + 1;

    days.push({
      date: currentDate.date(dayOfMonth),
      dayOfMonth: dayOfMonth,
      isCurrentMonth: true,
    });
  }

  return days;
};

export const getDaysForPreviousMonth = (
  currentDate: dayjs.Dayjs,
): ICalendayDay[] => {
  const startDate = currentDate.startOf('month').startOf('week');
  const startDateMonth = startDate.month();

  if (startDateMonth === currentDate.month()) {
    return [];
  }

  const daysInMonth = startDate.daysInMonth();
  const days: ICalendayDay[] = [];

  for (let index = startDate.get('date'); index <= daysInMonth; index++) {
    days.push({
      date: currentDate.subtract(1, 'month').date(index),
      dayOfMonth: index,
      isCurrentMonth: false,
    });
  }

  return days;
};

export const createCalendar = (date: dayjs.Dayjs): ICalendayDay[] => {
  return [...getDaysForPreviousMonth(date), ...getDaysForCurrentMonth(date)];
};
